// snackbar-service.ts
import { type BdkSnackbar } from '@breuni-ui/bdk-snackbar';

export async function pushToSnackbar(
  title: string,
  img?: string,
  buttonText?: string,
  callbackFunction?: (id: string) => void,
  imageAltText?: string,
  disableTextMasking?: boolean,
): Promise<string | undefined> {
  await customElements.whenDefined('bdk-snackbar');
  const snackbar = document.querySelector('bdk-snackbar') as BdkSnackbar;

  if (!snackbar) {
    console.error('bdk-snackbar element not found in the DOM.');
    return undefined;
  }

  return snackbar.show({
    text: title,
    content: img ? `<img src="${img}" alt="${imageAltText}" style="width: 100%; margin-top: 4px;">` : undefined,
    actionButtonText: buttonText,
    actionButtonAction: callbackFunction,
    closeButton: !!callbackFunction,
    showTimeIndicator: true,
    disableTextMasking: disableTextMasking,
  });
}

// Bypasses BdkSnackbar's minimumDisplayTime guard via its internal hideSnackbar method.
// closeSnackbarById defers dismissal until minimumDisplayTime (20s for action-button snackbars)
// has elapsed, which is too late for rollback scenarios.
export function dismissSnackbar(id: string) {
  const snackbar = document.querySelector('bdk-snackbar') as BdkSnackbar;
  if (!snackbar) return;
  (
    snackbar as unknown as { hideSnackbar(id: string, forceRemove: boolean, skipMinimumDisplayTime: boolean): void }
  ).hideSnackbar(id, false, true);
}
